import { getLenderConcession } from './getLenderConcession';

export const concessionService = {
  getLenderConcession,
};
